/**
 * Status values reach the drill-downs exactly as the API stores them —
 * lower-cased, occasionally underscored (`active`, `open`, `in_progress`).
 * The detail dialogs render a status as bold text rather than a chip, so it
 * has to be presentable on its own: underscores opened out, each word capped.
 */
export const formatStatusLabel = (status: string): string =>
  status
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());

/**
 * Billing cadence, spelled the way the Invoice Schedule table spells it.
 * `BillingCadence` is stored `monthly` / `annual`, but the schedule column
 * renders RepairShopr's own frequency string — "Monthly" / "Annually" — and a
 * commitment reading "Annual" beside a schedule reading "Annually" invites the
 * reader to wonder whether they are the same thing. Unknown values fall back to
 * plain capitalisation rather than disappearing.
 */
const CADENCE_LABELS: Record<string, string> = {
  monthly: 'Monthly',
  annual: 'Annually',
};

export const formatCadenceLabel = (cadence: string): string =>
  CADENCE_LABELS[cadence.toLowerCase()] ?? formatStatusLabel(cadence);
